module.exports = __webpack_public_path__ + "img/delete-keypad.f1f01689.svg";